// i18n keys of b13 S3 (PAY-6): a PND.1 / SSO line's History in the Tax panels (src/components/Tax/PayLineHistory.tsx,
// opened from Pnd1Panel / SsoPanel in src/components/Tax/index.tsx) and the auditor's read-only net (src/utils/api.ts),
// en / zh / th, the emplog.ts pattern.
// ⛔ Fill all three: an empty value falls back or renders blank. ⛔ No currency word: a wage is a figure (money()).
// ⛔ ONLY THE SCREEN'S OWN WORDS. Names, ID numbers, wages, who made a change and the payroll run's number are data,
// shown as recorded in every language. The door a change came through is mapped from its `source` by prefix
// (plog_src_*) and never printed raw.
export const en: Record<string, string> = {
  plog_history: 'History',
  plog_title: 'Line history',
  plog_act_add: 'Line added',
  plog_act_edit: 'Changed',
  plog_act_remove: 'Line deleted',
  plog_act_resync_add: 'Added by Generate / Re-sync from the roster',
  plog_act_resync_remove: 'Removed by Generate / Re-sync from the roster',
  plog_act_roster_sync: 'Salary change carried into this month',
  plog_field_wage: 'Wage',
  plog_field_id_number: 'ID number',
  plog_field_name: 'Name',
  plog_field_override: 'Fixed amount (cleared by the wage change)',
  plog_origin_roster: 'Made from the employee roster on {{date}}.',
  plog_origin_hand: 'Added by hand on {{date}}.',
  plog_origin_backfilled: 'Rebuilt by the system after the month was marked filed.',
  plog_origin_payroll: 'Written by payroll run {{docNos}}.',
  plog_origin_taken: 'Replaced by payroll run {{docNo}}.',
  plog_src_pnd1: 'Tax › PND.1',
  plog_src_sso: 'Tax › SSO',
  plog_src_employee: 'Salary change in the employee record or an import',
  plog_src_portal: "The client's request, applied",
  plog_src_other: 'Another screen',
  plog_empty: 'No change to this line has been recorded. Changes are recorded from this version onwards.',
  plog_by: 'by {{name}}',
  plog_through: 'Through: {{door}}',
  plog_load_failed: 'The history could not be loaded: {{error}}',
  // (b13 review) The hint a read-only seat (the auditor) reads instead of the one inviting an edit or Generate.
  plog_ro_snap: 'Saved snapshot of this month. This login reads it and changes nothing here.',
  plog_ro_preview: 'Live preview from the employee roster — nothing is saved for this month yet. This login reads it and changes nothing here.',
  plog_ro_refused: 'This login may read PND.1 and SSO, not change them.',
};

export const zh: Record<string, string> = {
  plog_history: '历史',
  plog_title: '本行修改历史',
  plog_act_add: '新增一行',
  plog_act_edit: '修改',
  plog_act_remove: '删除一行',
  plog_act_resync_add: '按员工名单生成 / 重新同步时加入',
  plog_act_resync_remove: '按员工名单生成 / 重新同步时移除',
  plog_act_roster_sync: '调薪同步到本月',
  plog_field_wage: '工资',
  plog_field_id_number: '证件号',
  plog_field_name: '姓名',
  plog_field_override: '手填金额(随工资修改清除)',
  plog_origin_roster: '{{date}} 按员工名单生成。',
  plog_origin_hand: '{{date}} 手工添加。',
  plog_origin_backfilled: '该月标记为已申报后由系统补录。',
  plog_origin_payroll: '由工资单 {{docNos}} 写入。',
  plog_origin_taken: '已被工资单 {{docNo}} 取代。',
  plog_src_pnd1: '税务 › PND.1',
  plog_src_sso: '税务 › 社保',
  plog_src_employee: '员工资料或导入中的调薪',
  plog_src_portal: '客户的申请(已执行)',
  plog_src_other: '其他界面',
  plog_empty: '本行没有修改记录。修改从本版本起开始记录。',
  plog_by: '操作人 {{name}}',
  plog_through: '来源:{{door}}',
  plog_load_failed: '无法加载历史:{{error}}',
  plog_ro_snap: '本月已保存的快照。此登录只能查看,不能在此修改。',
  plog_ro_preview: '按当前员工名单的实时预览——本月尚未保存。此登录只能查看,不能在此修改。',
  plog_ro_refused: '此登录只能查看 PND.1 和社保,不能修改。',
};

export const th: Record<string, string> = {
  plog_history: 'ประวัติ',
  plog_title: 'ประวัติการแก้ไขรายการนี้',
  plog_act_add: 'เพิ่มรายการ',
  plog_act_edit: 'แก้ไข',
  plog_act_remove: 'ลบรายการ',
  plog_act_resync_add: 'เพิ่มโดยการสร้าง / ซิงค์ใหม่จากรายชื่อพนักงาน',
  plog_act_resync_remove: 'นำออกโดยการสร้าง / ซิงค์ใหม่จากรายชื่อพนักงาน',
  plog_act_roster_sync: 'การปรับเงินเดือนที่นำมาใช้ในเดือนนี้',
  plog_field_wage: 'ค่าจ้าง',
  plog_field_id_number: 'เลขประจำตัว',
  plog_field_name: 'ชื่อ',
  plog_field_override: 'จำนวนที่กำหนดเอง (ล้างเมื่อแก้ค่าจ้าง)',
  plog_origin_roster: 'สร้างจากรายชื่อพนักงานเมื่อ {{date}}',
  plog_origin_hand: 'เพิ่มด้วยมือเมื่อ {{date}}',
  plog_origin_backfilled: 'ระบบสร้างย้อนหลังหลังจากเดือนนี้ถูกทำเครื่องหมายว่ายื่นแล้ว',
  plog_origin_payroll: 'บันทึกโดยรายการเงินเดือน {{docNos}}',
  plog_origin_taken: 'ถูกแทนที่โดยรายการเงินเดือน {{docNo}}',
  plog_src_pnd1: 'ภาษี › ภ.ง.ด.1',
  plog_src_sso: 'ภาษี › ประกันสังคม',
  plog_src_employee: 'การปรับเงินเดือนในข้อมูลพนักงานหรือการนำเข้า',
  plog_src_portal: 'คำขอของลูกค้า (ดำเนินการแล้ว)',
  plog_src_other: 'หน้าจออื่น',
  plog_empty: 'ยังไม่มีการบันทึกการแก้ไขรายการนี้ การแก้ไขจะถูกบันทึกตั้งแต่เวอร์ชันนี้เป็นต้นไป',
  plog_by: 'โดย {{name}}',
  plog_through: 'ผ่าน: {{door}}',
  plog_load_failed: 'โหลดประวัติไม่ได้: {{error}}',
  plog_ro_snap: 'สแนปช็อตที่บันทึกไว้ของเดือนนี้ บัญชีผู้ใช้นี้ดูได้อย่างเดียว แก้ไขที่นี่ไม่ได้',
  plog_ro_preview: 'ตัวอย่างจากรายชื่อพนักงานปัจจุบัน — เดือนนี้ยังไม่ได้บันทึก บัญชีผู้ใช้นี้ดูได้อย่างเดียว แก้ไขที่นี่ไม่ได้',
  plog_ro_refused: 'บัญชีนี้ดู ภ.ง.ด.1 และประกันสังคมได้เท่านั้น แก้ไขไม่ได้',
};
